export default __webpack_public_path__ + "static/media/avatar.f68677f1.png";